import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import StatusBadge from './StatusBadge';

const PilgrimMobileCard = ({ pilgrim, isSelected, onSelect, currentLanguage = 'fr' }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const labels = {
    fr: {
      phone: 'Téléphone',
      email: 'Email',
      group: 'Groupe',
      visa: 'Visa',
      documents: 'Documents',
      payment: 'Paiement',
      progress: 'Progression',
      viewProfile: 'Voir le profil',
      actions: 'Actions'
    },
    ar: {
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      group: 'المجموعة',
      visa: 'التأشيرة',
      documents: 'الوثائق',
      payment: 'الدفع',
      progress: 'التقدم',
      viewProfile: 'عرض الملف',
      actions: 'الإجراءات'
    }
  };

  const getProgressColor = (progress) => {
    if (progress >= 80) return 'bg-success';
    if (progress >= 50) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-warm">
      <div className="flex items-start gap-3 mb-3">
        <Checkbox
          checked={isSelected}
          onChange={(e) => onSelect(pilgrim?.id, e?.target?.checked)}
        />
        <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
          <Image
            src={pilgrim?.avatar}
            alt={pilgrim?.avatarAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground mb-1">{pilgrim?.name}</h3>
          <p className="caption text-muted-foreground">{pilgrim?.passportNumber}</p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      </div>
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div>
          <p className="caption text-muted-foreground mb-1">{labels?.[currentLanguage]?.visa}</p>
          <StatusBadge status={pilgrim?.visaStatus} type="visa" currentLanguage={currentLanguage} />
        </div>
        <div>
          <p className="caption text-muted-foreground mb-1">{labels?.[currentLanguage]?.payment}</p>
          <StatusBadge status={pilgrim?.paymentStatus} type="payment" currentLanguage={currentLanguage} />
        </div>
      </div>
      <div className="mb-3">
        <div className="flex items-center justify-between mb-2">
          <span className="caption text-muted-foreground">{labels?.[currentLanguage]?.progress}</span>
          <span className="caption text-foreground data-text font-medium">{pilgrim?.caseProgress}%</span>
        </div>
        <div className="bg-muted rounded-full h-2 overflow-hidden">
          <div 
            className={`h-full ${getProgressColor(pilgrim?.caseProgress)} transition-smooth`}
            style={{ width: `${pilgrim?.caseProgress}%` }}
          />
        </div>
      </div>
      {isExpanded && (
        <div className="border-t border-border pt-3 space-y-3">
          <div>
            <p className="caption text-muted-foreground mb-1">{labels?.[currentLanguage]?.phone}</p>
            <p className="text-sm text-foreground">{pilgrim?.phone}</p>
          </div>
          <div>
            <p className="caption text-muted-foreground mb-1">{labels?.[currentLanguage]?.email}</p>
            <p className="text-sm text-foreground truncate">{pilgrim?.email}</p>
          </div>
          <div>
            <p className="caption text-muted-foreground mb-1">{labels?.[currentLanguage]?.group}</p>
            <p className="text-sm text-foreground">{pilgrim?.group}</p>
          </div>
          <div>
            <p className="caption text-muted-foreground mb-1">{labels?.[currentLanguage]?.documents}</p>
            <StatusBadge status={pilgrim?.documentStatus} type="document" currentLanguage={currentLanguage} />
          </div>
        </div>
      )}
      <div className="flex gap-2 mt-3 pt-3 border-t border-border">
        <Button
          variant="outline"
          iconName="Eye"
          iconPosition="left"
          onClick={() => navigate('/pilgrim-profile', { state: { pilgrimId: pilgrim?.id } })}
          fullWidth
        >
          {labels?.[currentLanguage]?.viewProfile}
        </Button>
        <Button
          variant="ghost"
          size="icon"
          iconName="MoreVertical"
        />
      </div>
    </div>
  );
};

export default PilgrimMobileCard;